module.exports = __webpack_public_path__ + "images/5355991237e47b631e84acad9f749b73-LoginBrandImg.jpg";